import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

const appDefault = {
  firmApp: null,
  app: null,
  appName: null,
  firm: null,
  firmName: null,
  portalUrl: null,
  apiUrl: null,
  appNumber: null,
  isBms: false,
  reportUrl: null
}

export const appsStore = defineStore('apps', {
  state: () => ({
    loading: {
      firmApps: false,
      apps: false
    },
    firm: null,
    apps: [],
    firmApps: [],
    firmApp: JSON.parse(JSON.stringify(appDefault))
  }),
  actions: {
    setApp(app) {
      if (app === null) {
        this.firmApp = JSON.parse(JSON.stringify(appDefault))
      } else {
        this.firmApp = app
      }
      console.log('Set App', this.firmApp)
    },
    setAppData(data) {
      this.firmApp[data.name] = data.value
    },
    setFirm(id) {
      this.firm = id
    },
    async getApps(appNumber, reset = true) {
      this.loading.apps = true
      if (reset) {
        this.apps = []
      }
      let results = await api.get(`app/apps?appNumber=${appNumber}`)
      if (results) {
        if (!reset) {
          this.apps = this.apps.concat(results)
        } else {
          this.apps = results
        }
      }
      this.loading.apps = false
      console.log('Got Apps', this.apps)
      return this.apps
    },
    async getFirmApps() {
      this.loading.firmApps = true
      this.firmApps = []
      let results = await api.get('firm/firmApps?id=1&dir=2')
      if (results) {
        this.firmApps = results
        this.firmApps.forEach((element) => {
          element.isRemove = false
        })
      }
      this.loading.firmApps = false
      return this.firmApps
    },
    async saveApp(data) {
      let results = await api.post('app/saveApp', data)
      return results
    },
    async saveFirmApp() {
      let results = await api.post('firm/saveApp', this.firmApp)
      return results
    },
    async deleteApp() {
      let results = await api.get(`firm/deleteApp?firmApp=${this.firmApp.firmApp}`)
      return results
    }
  }
})
